import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = props => (
  <nav
    id="topNav"
    className="navbar navbar-default mb-3 navbar-expand-lg fixed-top"
    data-toggle="affix"
    style={{ borderTop: '10px solid black' }}
  >
    <a
      href=""
      className="navbar-toggler-anim toggler-offcanvas my-auto collapsed border-0 mr-2"
      data-toggle="collapse"
      data-target="offcanvasNavbar"
    >
      <span />
      <span />
      <span />
    </a>
    <a className="navbar-brand page-scroll text-uppercase wide-space link" href="/">
      BusinessDNA
    </a>
    <button
      className="navbar-toggler collapsed border-0"
      type="button"
      data-toggle="collapse"
      data-target="collapsingNavbar"
    >
      <span />
      <span />
      <span />
    </button>
    <div className="collapse navbar-collapse border-0" id="collapsingNavbar">
      <ul className="nav navbar-nav">
        {props.navigation.left.map(({ link, name }) => (
          <li className="nav-item" key={link}>
            <NavLink to={link} exact activeClassName="active" className="nav-link page-scroll">
              {name}
            </NavLink>
          </li>
        ))}
      </ul>
      <ul className="nav navbar-nav ml-auto">
        {props.navigation.right.map(({ link, name }) => (
          <li className="nav-item" key={link}>
            <NavLink to={link} exact activeClassName="active" className="nav-link page-scroll">
              {name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  </nav>
);
export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js